import { Routes as AppRoutes } from "@/constants/routes";

import { UrlParams } from "./urlParams";

export const getFunnelFoxUrlParams = () => {
    const rawQuery = window.location.search.substring(1);
    const fixedQuery = rawQuery.replace(/\+/g, "%2B");
    const urlParams = new URLSearchParams(fixedQuery);

    return urlParams;
};

export const getFunnelFoxDeviceId = () => {
    const isFunnelFoxUrl = window.location.pathname.includes(AppRoutes.FFPaywall);
    const ffUserId = new URLSearchParams(window.location.search).get(UrlParams.FF_USER_ID);
    const ffDeviceId = `fnlfx_${ffUserId}`;

    if (isFunnelFoxUrl && ffUserId) {
        return ffDeviceId;
    }

    return undefined; // fallback to make amplitude generate device id
};
